import { render, staticRenderFns } from "./SliderPublicDisplayItem.vue?vue&type=template&id=6592fd55&scoped=true"
import script from "./SliderPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./SliderPublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./SliderPublicDisplayItem.vue?vue&type=style&index=0&id=6592fd55&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592fd55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6592fd55')) {
      api.createRecord('6592fd55', component.options)
    } else {
      api.reload('6592fd55', component.options)
    }
    module.hot.accept("./SliderPublicDisplayItem.vue?vue&type=template&id=6592fd55&scoped=true", function () {
      api.rerender('6592fd55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/SliderPublicDisplayItem.vue"
export default component.exports